namespace $.$$ {
	export class $eve_app_page_themer extends $.$eve_app_page_themer {}
}
